import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const BPHero = () => {
  const { t } = useTranslation();

  return (
  <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
    <div className="absolute inset-0">
      <img
        src="https://public.readdy.ai/ai/img_res/6de4d075e8349f16c3c995edb37dcf87.jpg"
        alt="Blue Protect"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050010]/85 via-[#050010]/70 to-[#050010]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050010]/60 via-transparent to-[#050010]/60" />
    </div>

    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {[...Array(14)].map((_, i) => (
        <div key={i} className="absolute w-1 h-1 rounded-full bg-violet-400/40"
          style={{ left: `${6 + i * 7}%`, top: `${15 + (i % 5) * 15}%`, animation: `pulse ${2 + (i % 3)}s ease-in-out infinite`, animationDelay: `${i * 0.3}s` }} />
      ))}
    </div>

    <div className="relative z-10 w-full text-center px-6 lg:px-12 flex flex-col items-center">
      <div className="inline-flex items-center gap-2 px-4 py-2 bg-violet-900/30 border border-violet-500/30 rounded-full mb-8">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-shield-star-line text-violet-400 text-xs" />
        </div>
        <span className="text-violet-300 text-xs font-semibold uppercase tracking-widest">{t('bp_hero_badge')}</span>
      </div>

      <h1 className="text-5xl lg:text-7xl font-black text-white mb-6 leading-tight">
        Blue Protect<br />
        <span className="text-transparent bg-gradient-to-r from-violet-400 via-fuchsia-400 to-violet-500 bg-clip-text">
          {t('bp_hero_title')}
        </span>
      </h1>

      <p className="text-white/55 text-base lg:text-lg max-w-2xl mx-auto leading-relaxed mb-4">{t('bp_hero_sub')}</p>
      <p className="text-violet-300/70 text-sm max-w-xl mx-auto leading-relaxed mb-12">{t('bp_hero_pure')}</p>

      <div className="flex flex-wrap justify-center gap-3 mb-12">
        {[
          { flag: '🇸🇷', culture: t('bp_hero_surinamese'), name: 'Ogri Ai' },
          { flag: '🪬', culture: t('bp_hero_hindustani'), name: 'Nazar' },
          { flag: '🇪🇸', culture: t('bp_hero_spanish'), name: 'Azul' },
        ].map(n => (
          <div key={n.name} className="flex items-center gap-2 px-4 py-2 bg-violet-900/25 border border-violet-500/20 rounded-full">
            <span className="text-base">{n.flag}</span>
            <span className="text-violet-300/70 text-xs">{n.culture}:</span>
            <span className="text-violet-300 text-xs font-bold">{n.name}</span>
          </div>
        ))}
      </div>

      <div className="flex flex-col sm:flex-row items-center gap-4 mb-16">
        <Link to="/shop?cat=blue-protect"
          className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-bold text-sm rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-shopping-bag-line text-sm" />
          </div>
          {t('bp_hero_view_products')}
        </Link>
        <a href="#producten"
          className="inline-flex items-center gap-2 px-8 py-4 bg-white/5 border border-white/15 text-white/80 font-semibold text-sm rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-down-line text-sm" />
          </div>
          {t('bp_hero_discover')}
        </a>
      </div>

      <div className="flex flex-wrap justify-center gap-8 lg:gap-16">
        {[
          { value: '4×', label: t('bp_hero_stat1') },
          { value: '4.9★', label: t('bp_hero_stat2') },
          { value: '293+', label: t('bp_hero_stat3') },
          { value: '100%', label: t('bp_hero_stat4') },
        ].map(stat => (
          <div key={stat.label} className="text-center">
            <p className="text-violet-400 font-black text-2xl lg:text-3xl">{stat.value}</p>
            <p className="text-white/35 text-xs mt-1">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>

    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
      <div className="w-5 h-5 flex items-center justify-center">
        <i className="ri-arrow-down-s-line text-white/30 text-lg" />
      </div>
    </div>
  </section>
  );
};
